


















import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "uc-page-header"
})
export default class UcPageHeaderComponent extends Vue {

  innerVisible=false;
  
  showMenu(value: MouseEvent) {
    let menu = this.$refs.dropmenu as any;
    menu.show(value);
  }
clickContextMenuLang(val:string){
    
    // this.$locale.currentLang = val    
    this.$router.replace({name: this.$route.name, params: Object.assign(this.$route.params, {lang: val}), query: this.$route.query});
    location.reload();
    // this.$router.go(0);
    let menu = this.$refs.dropmenu as any;
    menu.hide();
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/header/uc-page-header.vue